import React, {Component} from 'react';
import {connect} from "react-redux";
import MaterialIcon from '../../MaterialIcon';

import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import messageCodes from "../../../utils/messageCodes";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";

class LimitSameValues extends Component {
    constructor(props){
        super(props);
        this.state = {
            isNumberInputSelected: false,
            dynamicProperty: '',
            limit: 1,
            ignoreEmptyValues: false,
            limitSameValues: []
        };
        this.toggleNumberInput = this.toggleNumberInput.bind(this);
        this.inputHandle = this.inputHandle.bind(this);
        this.checkControl = this.checkControl.bind(this);
        this.addData = this.addData.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }
    componentDidMount(){
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.settings) {
            const settingsData = this.props.clickedNodeInfo.extras.options.settings;
            if(settingsData.limitSameValues && settingsData.limitSameValues.length > 0) {
                this.setState({
                    limitSameValues: settingsData.limitSameValues,
                    isNumberInputSelected: true
                });
            }
        }
    }
    toggleNumberInput() {
        this.setState({
            isNumberInputSelected: !this.state.isNumberInputSelected
        }, ()=>{
            if (!this.state.isNumberInputSelected) {
                this.setState({
                    limitSameValues: []
                }, () => {
                    const limitSameValues = Object.values(Object.assign({}, this.state.limitSameValues));
                    const settingsData = {
                        limitSameValues
                    }
                    const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
                    clickedNodeInfo.extras.options.settings = settingsData;
                    clickedNodeInfo.extras.name = clickedNodeInfo.name;        
                    this.props.clickedNodeAction(clickedNodeInfo);
                });
            }
        });
    }

    inputHandle(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    checkControl() {
        this.setState({
            ignoreEmptyValues: !this.state.ignoreEmptyValues
        });
    }
    addData() {
        const {dynamicProperty, limit, ignoreEmptyValues} = this.state;
        if(dynamicProperty === ''){
            const title = 'Error';
            const description = 'Limit Property Name is invalid';
            this.props.showToastForFrontend(messageCodes.CUSTOM_TOAST(title,description, 'error'));
            return false;
        }

        const limitSameValues = Object.values(Object.assign({}, this.state.limitSameValues));
        limitSameValues.push({
            dynamicProperty,
            limit,
            ignoreEmptyValues
        });
        this.setState({
            limitSameValues,
            dynamicProperty: '',
            limit: 1,
            ignoreEmptyValues: false
        });

        const settingsData = {
            limitSameValues
        }
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        clickedNodeInfo.extras.options.settings = settingsData;
        clickedNodeInfo.extras.name = clickedNodeInfo.name;        
        this.props.clickedNodeAction(clickedNodeInfo);

    }
    removeItem(index){
        const limitSameValues = Object.values(Object.assign({}, this.state.limitSameValues));
        limitSameValues.splice(index, 1);
        this.setState({
            limitSameValues
        });
        const settingsData = {
            limitSameValues
        }
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        clickedNodeInfo.extras.options.settings = settingsData;
        clickedNodeInfo.extras.name = clickedNodeInfo.name;        
        this.props.clickedNodeAction(clickedNodeInfo);
    }
    render() {
        const {dynamicProperty, limit, ignoreEmptyValues, limitSameValues} = this.state;
        return (
            <div className="filter-group">
                <div className="filter-group-header">
                    <label className="checkbox-wrapper">
                        <input type="checkbox" className="checkbox" checked={ this.state.isNumberInputSelected } onChange={ this.toggleNumberInput } />
                        Limit Same Values
                    </label>
                </div>
                {this.state.isNumberInputSelected &&
                <div className="filter-group-content">
                    <div className="limit-form-area">
                        <div className="limit-form">
                            <label className="item">
                                <input name="dynamicProperty" onChange={this.inputHandle} className="panel-input" placeholder="Dynamic property name" type="text" value={dynamicProperty} />
                            </label>
                            <label className="item">
                                <input name="limit" onChange={this.inputHandle} className="panel-input" placeholder="Limit value" type="number" value={limit} />
                            </label>
                            <label className="item checkbox-item">
                                <input checked={ignoreEmptyValues} onChange={this.checkControl} type="checkbox" className="checkbox" />
                                <span>Ignore empty values</span>
                            </label>
                            <button className="save-button" onClick={this.addData}>
                                <MaterialIcon icon="add"/>
                                Add
                            </button>
                        </div>
                        <div className="list-items">
                            {
                                limitSameValues.map((val,key) => {
                                    return (
                                        <div className="list" key={key}>
                                            <label className="item">
                                                <span className="text">{val.dynamicProperty}</span>
                                            </label>
                                            <label className="item">
                                                <span className="count">{val.limit}</span>
                                            </label>
                                            <label className={`item checkbox-item ${val.ignoreEmptyValues ? '' : 'disabled'}`}>
                                                <input type="checkbox"  disabled checked={val.ignoreEmptyValues} className="checkbox" />
                                                <span>Ignore empty values</span>
                                            </label>
                                            <button className="close-button" onClick={() => this.removeItem(key)}>
                                                <MaterialIcon icon="close"/>
                                            </button>    
                                        </div> 
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo
    }
}
export default connect(mapStateToProps, {clickedNodeAction, showToastForFrontend, showToastForBackend})(LimitSameValues);